import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Input } from '../../components/shared/Input';
import { Button } from '../../components/shared/Button';
import { Card } from '../../components/shared/Card';
import { useCambiarPassword } from '../../hooks/useAuth';
import { ApiError } from '../../api/apiClient';

interface DatosCambiarPassword {
  passwordActual: string;
  passwordNueva: string;
  confirmarPassword: string;
}

/** Cambio de contraseña autoservicio para un usuario ya logueado (distinto del
 * challenge de primer login — ver NuevaPasswordForm). */
export function CambiarPasswordPage() {
  const cambiarPassword = useCambiarPassword();
  const [error, setError] = useState<string>();
  const [exito, setExito] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<DatosCambiarPassword>();

  const enviar = (datos: DatosCambiarPassword) => {
    setError(undefined);
    setExito(false);
    cambiarPassword.mutate(
      { passwordActual: datos.passwordActual, passwordNueva: datos.passwordNueva },
      {
        onSuccess: () => {
          setExito(true);
          reset();
        },
        onError: (err) => setError(err instanceof ApiError ? err.message : 'No se pudo cambiar la contraseña'),
      },
    );
  };

  return (
    <div className="max-w-md">
      <Card className="p-8">
        <form onSubmit={handleSubmit(enviar)} data-testid="cambiar-password-form" className="flex flex-col gap-4">
          <Input
            label="Contraseña actual"
            type="password"
            placeholder="••••••••"
            error={errors.passwordActual?.message}
            {...register('passwordActual', { required: 'La contraseña actual es requerida' })}
          />
          <Input
            label="Nueva contraseña"
            type="password"
            placeholder="••••••••"
            error={errors.passwordNueva?.message}
            {...register('passwordNueva', {
              required: 'La nueva contraseña es requerida',
              minLength: { value: 8, message: 'Debe tener al menos 8 caracteres' },
            })}
          />
          <Input
            label="Confirmar nueva contraseña"
            type="password"
            placeholder="••••••••"
            error={errors.confirmarPassword?.message}
            {...register('confirmarPassword', {
              required: 'Confirma la nueva contraseña',
              validate: (valor) => valor === watch('passwordNueva') || 'Las contraseñas no coinciden',
            })}
          />
          {error && <p className="text-xs text-danger" role="alert">{error}</p>}
          {exito && <p className="text-xs text-success" role="status">Contraseña actualizada correctamente.</p>}
          <Button type="submit" disabled={cambiarPassword.isPending}>
            {cambiarPassword.isPending ? 'Guardando…' : 'Cambiar contraseña'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
